export default __webpack_public_path__ + "static/media/g2020-6.80211d34.jpeg";